import instanceQuery from 'graphql/queries/salesLedger/SalesInvoicePostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';

const SalesInvoicePostingPreview = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default SalesInvoicePostingPreview;
